import { put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IKnoOrganisationsChildrenResponse } from 'APIPackage/CatalogsModule/interfaces/IKnoOrganisationsChildrenResponse';
import { fetchKnoErvkOrganizationsSearch } from 'APIPackage/CatalogsModule/services/knoOrganisationsApi';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';

import {
  setErvkOrganisations,
  changeKnoSetPlanHistoryChanges,
  startProcessFormSubmit,
  changeKnoGetPlanHistoryChanges,
} from '../actions/ChangeKnoInPlanActions';
import { ChangeKnoInPlanActionsEnum } from '../enums/ChangeKnoInPlanActionsEnum';
import { getErvkOrganisationsSearchQuery } from '../selectors/changeKnoInPlanSelectors';
import { IControlWithDate } from '../../APIPackage/DictionariesModule/interfaces/IControlWithDate';
import { fetchDictionaryKnoSupervision } from '../../APIPackage/DictionariesModule/services/dictionariesApi';
import { addNoticeAction, removeAllNoticesAction } from '../../CorePackage/NotificationModule/actions/NoticeActions';
import { NoticeTypesEnum } from '../../CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from '../../CorePackage/NotificationModule/enums/MessageTypesEnum';
import { changeKnoForKnmsInPlan, fetchPlanHistoryChanges } from '../../APIPackage/KnmModule/services/knmPlanApi';
import { IPlanKnoChangeHistoryItem } from '../components/IPlanKnoChangeHistoryItem';
import { getLawInterfaceFromStorage } from '../../CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { LawInterfacesEnum } from '../../CorePackage/MainModule/enums/LawInterfacesEnum';

const PAGE_SIZE = '10';

export function* watchChangeKnoInPlanSaga() {
  yield takeEvery(ChangeKnoInPlanActionsEnum.CHANGE_KNO_ERVK_ORGANIZATION_GET, getOrganisationsSaga);
  yield takeEvery(ChangeKnoInPlanActionsEnum.CHANGE_KNO_FORM_SUBMIT, changeKnoFormSubmitSaga);
  yield takeEvery(ChangeKnoInPlanActionsEnum.CHANGE_KNO_PLAN_HISTORY_CHANGES_GET, getPlanHistoryChangesSaga);
}

function* getPlanHistoryChangesSaga() {
  function* funcTry() {
    const res: IPlanKnoChangeHistoryItem[] = yield fetchPlanHistoryChanges();

    yield put(changeKnoSetPlanHistoryChanges(res));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* getOrganisationsSaga() {
  function* funcTry() {
    const state: IRootState = yield select();

    const searchQuery = getErvkOrganisationsSearchQuery(state);

    if (searchQuery) {
      const isNumber = /^\d+$/.test(searchQuery);

      const res: IKnoOrganisationsChildrenResponse = yield fetchKnoErvkOrganizationsSearch({
        query: searchQuery,
        adminLevel: undefined,
        searchCriteria: isNumber ? 'OGRN' : 'NAME',
        order: 'fullName',
        page: '0',
        size: PAGE_SIZE,
      });

      yield put(setErvkOrganisations(res.list));
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* changeKnoFormSubmitSaga(action: ActionType<typeof startProcessFormSubmit>) {
  function* funcTry() {
    yield put(removeAllNoticesAction());

    const isErknm = getLawInterfaceFromStorage() === LawInterfacesEnum.FZ_248;

    const knmPlanFindData = action.payload.planData;
    const supervisionTypeDictVersionId = knmPlanFindData?.knmPlanData?.supervisionTypeErknm?.dictVersionId;
    const selectedErvkKnoOrganization = action.payload.ervkKnoOrganization;
    const selectedErvkKnoOrganizationUid =
      selectedErvkKnoOrganization?.guid?.toString() || selectedErvkKnoOrganization?.ervkVersionUuid;

    if ((supervisionTypeDictVersionId || !isErknm) && selectedErvkKnoOrganizationUid) {
      let data!: IControlWithDate;

      if (supervisionTypeDictVersionId) {
        try {
          data = yield fetchDictionaryKnoSupervision(selectedErvkKnoOrganizationUid, supervisionTypeDictVersionId);
        } catch (err) {
          yield put(
            addNoticeAction({
              noticeType: NoticeTypesEnum.ERROR,
              messageType: MessageTypesEnum.GET_KNO_SUPERVISION,
              renderContent: 'Для указанного КНО не применим вид контроля, указанный в плане',
            }),
          );
        }
      }

      try {
        if (data || !isErknm) {
          yield changeKnoForKnmsInPlan(knmPlanFindData?.id, selectedErvkKnoOrganizationUid, action.payload.stpNumber);
          yield put(
            addNoticeAction({
              noticeType: NoticeTypesEnum.SUCCESS,
              messageType: MessageTypesEnum.CHANGE_KNO,
              renderContent: 'Операция выполнена успешно',
            }),
          );
        }
      } catch (err) {
        yield put(
          addNoticeAction({
            noticeType: NoticeTypesEnum.ERROR,
            messageType: MessageTypesEnum.CHANGE_KNO,
            renderContent: 'Ошибка при выполнении операции',
          }),
        );
      }
      yield put(changeKnoGetPlanHistoryChanges());
    }
  }
  yield sagaWrapper({
    funcTry,
  });
}
